export default {
  addOns: '附加项目',
  unavailable: '不可用',
  person: '人',
  people: '人',
  reserveNow: '立即预订',
  selectTime: '选择时间',
  select: '选择',
  reserve: '预订',
  time: '时间',
  tier: '等级',
  questions: '问题',
  addToCart: '加入购物车',
  checkout: '结账',
  total: '总计',
  availability: '可用性',
  whatsIncluded: '包含内容',
  showMore: '显示更多',
  showLess: '收起',
  session: '场次',
  viewDetails: '查看详情',
  findAvailability: '查找可用性',
  loading: '加载中',
  capacity: '容量',
  noAvailableSessionsOnThisDate: '该日期无可用场次',
  noGroupAvailableOnThisDateAndTime: '该日期和时间无可用的 {{groupTitle}}',
  noCollectionFound: '未找到任何合集！',
  noResourceGroupFound: '未找到资源组！',
  noData: '无数据！',
  continue: '继续',
};
